import { render, staticRenderFns } from "./WorkflowNavigationTitle.vue?vue&type=template&id=4251ac08&scoped=true"
import script from "./WorkflowNavigationTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowNavigationTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowNavigationTitle.vue?vue&type=style&index=0&id=4251ac08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251ac08",
  null
  
)

export default component.exports